const projects = [
    {
        id:1,
        sid: "sprinkler",
        title: "Sprinkler Assembler",
        text: "This is a project to automate the manufacturing process for popup sprinkler systems. We customized a production work-flow to make manufacturing quicker, more efficient, and still be made in the USA. With Renew Engineering's manufacturing and automation experience, we were able to increase output and save our clients time and money.",
        images: [
            '/images/projects/sprinkler-1.jpg',
            '/images/projects/sprinkler-2.jpg',
            '/images/projects/sprinkler-3.jpg',
        ]
    },
    {
        id:2,
        sid: "observatory",
        title: "Observatory",
        text: "In Nov 2007, Renew Engineerng finished an exciting, complicated project. Mr. Derrick has always loved Astronomy and had a dream to have his own observatory. For the next year, We designed, constructed, and engineered an observatory building for Derrick. He created a building where the side wall and roof open for an amazing view of the stars with just a push of a button. Derrick is now able to have his high-tech telescopes opened to the night sky thanks to the design and construction from Renew Engineering.",
        images: [
            '/images/projects/observatory-1.jpg',
            '/images/projects/observatory-2.jpg',
            '/images/projects/observatory-3.jpg',
        ]
    },
    {
        id:3,
        sid: "futura",
        title: "Futura Industries",
        text: "For Over 10 years, Renew Engineering has worked with Futura Industries on various machining, manufacturing, and design projects. We have assisted in modifying their manufacturing process to eliminate bottle necks or other problems the company has faced. Wanting quicker set-ups, Renew Engineering helped find ways to make configuration changes faster and more efficient for a smoother manufacturing process.",
        images: [
            '/images/projects/futura-1.jpg',
            '/images/projects/futura-2.jpg',
            '/images/projects/futura-3.jpg',
        ]
    }

]

export default projects;